import * as React from "react";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { Settings, ScrollText, Wallet } from "lucide-react";
import { SettingsPage, SettingsIndexRedirect } from "@/pages/settings";
import { UsagePage } from "@/pages/usage";
import { AuditPage } from "@/pages/audit";
import { ProjectsPage } from "@/pages/projects";
import { CheckoutPage } from "@/pages/checkout";

export const settingsRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "settings",
      handle: { title: "Settings" },
      element: React.createElement(SettingsIndexRedirect),
    },
    {
      path: "settings/:section",
      handle: { title: "Settings" },
      element: React.createElement(SettingsPage),
    },
    {
      path: "usage",
      handle: { title: "Usage" },
      element: React.createElement(UsagePage),
    },
    { path: "audit", handle: { title: "Audit log" }, element: React.createElement(AuditPage) },
    {
      path: "projects",
      handle: { title: "Your projects" },
      element: React.createElement(ProjectsPage),
    },
    {
      path: "checkout",
      handle: { title: "Buy credits" },
      element: React.createElement(CheckoutPage),
    },
  ],
  shellRouteDefs: [
    {
      path: "/settings",
      title: "Settings",
      summary: "The name, members, and defaults of this project.",
    },
    {
      path: "/usage",
      title: "Usage",
      summary: "What this project has spent and what it has committed to spend.",
    },
    { path: "/audit", title: "Audit log", summary: "Who did what in this project, and when." },
  ],
};

export const settingsNav: FeatureNavModule = {
  navGroups: [
    {
      label: "Govern",
      items: [
        { to: "/usage", label: "Usage", icon: Wallet, end: false },
        { to: "/audit", label: "Audit log", icon: ScrollText, end: false },
        { to: "/settings", label: "Settings", icon: Settings, end: false },
      ],
    },
  ],
  settingsItem: {
    to: "/settings/general",
    label: "Settings",
    icon: Settings,
    end: false,
  },
};
